import { AxiosError, AxiosResponse } from 'axios';
import React, { useState, useEffect, useContext, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UseFormProps, SubmitHandler, useForm, UseFormReturn, FieldValues } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import cn from 'classnames';

import { Column, Wrapper } from '@/components/common/Page';
import { NotificationMatchbou } from '@/components/common/Notification/Matchbou';
import HeaderTitle from '@/components/common/Title/HeaderTitle';
import Modal from '@/components/common/Modal';
import { ConfirmationModal } from '@/components/common/Preview/ConfirmationModal';
import BaseButton from '@/components/common/Button/BaseButton';
import { TitleSectionTitle } from '@/components/common/Title/SectionTitle';
import { FormContainer } from '@/components/common/Form/Container';
import { PagesResumeConfirmationPreview } from '@/components/Resume/Preview/InputAgencyPreview';
import { ResumeFormSectionAddress } from '@/components/Resume/Form/Confirmation/SectionAddress';
// import { ResumeFormSectionCareer } from '@/components/Resume/Form/Confirmation/SectionCareer';
import {
  ResumeFormSectionEducations,
  TFormValues,
} from '@/components/Resume/Form/Confirmation/SectionEducations';
import { ResumeFormSectionFamily } from '@/components/Resume/Form/Confirmation/SectionFamily';
import { ResumeFormSectionHopeJob } from '@/components/Resume/Form/Confirmation/SectionHopeJob';
import { ResumeFormSectionInterestThings } from '@/components/Resume/Form/Confirmation/SectionInterestThings';
import { ResumeFormSectionLastUpdate } from '@/components/Resume/Form/Confirmation/SectionLastUpdate';
import { ResumeFormSectionProfile } from '@/components/Resume/Form/Confirmation/SectionProfile';
// import { ResumeFormSectionQualification } from '@/components/Resume/Form/Confirmation/SectionQualification';
import { ResumeFormSectionStatement } from '@/components/Resume/Form/Confirmation/SectionStatement';
import {
  toggleLoading,
  setUploadedImage,
  setSaved,
  notificationError,
  setPrepareFrag,
} from '@/redux/index';
import { DataLayerContext } from '@/components/common/DataLayerProviderContainer';
import { TPagesResumeFormValue } from '@/types/Pages/Resume';
import {
  MBResumeResponse,
  ResumeApi,
  ImagePhoto,
  PortfolioApi,
  Resume,
  CareerSummaryModel,
  Qualification,
  QualificationQTypeEnum,
  ResponseError,
  FileResponse,
  EducationData,
  EducationPatchRequest,
  UserApi,
  CareerHistoryApi,
  CareerHistory,
  Status,
  UserInfo,
} from '@/utils/api-client/api';
import { formatDate } from '@/utils/utils';
import { State } from '@/redux/state';

// Section用の型指定 共有なので読み込み側で指定してimportさせてる
export type TSectionProps = {
  id?: string;
  fetchData?: Resume | undefined;
  original?: string | any;
};

type TUserInfoKey = 'gender' | 'postal_code' | 'address2' | 'address1' | 'email';
type TUserResumeKey =
  | 'statement'
  | 'interest_things'
  | 'hope_job'
  | 'dependent_family'
  | 'partner'
  | 'duty_of_support';
type TCheckInput = {
  resume_update: boolean;
  resume_completed: boolean;
  cv_update: boolean;
  cv_completed: boolean;
};

/**
 * # 履歴書 編集 /mypage/resume/confirmation/edit
 * UI PC https://www.figma.com/design/C4gTbCbLEmoxo7sSCK3AJn/MATCHBOX_UI?node-id=14296-131660&t=jXKtTOpR8EkqT8ob-4
 * API https://matchbox-2021-doc-api-git-develop-prty.vercel.app/#operation/get-input_agency-resume
 */
export const PagesResumeConfirmationEdit = (): React.ReactElement => {
  const [notification, setNotification] = useState<boolean>(true);
  const [preview, setPreview] = useState<boolean>(true);
  const dispatch = useDispatch();
  const { push } = useContext(DataLayerContext);
  const history = useHistory();
  const userState = useSelector((state: State) => state.user);
  const [resumeData, setResumeData] = useState<Resume | undefined>();
  const [inputAgencyResumeData, setInputAgencyResumeData] = useState<Resume | undefined>();
  const [previewResumeData, setPreviewResumeData] = useState<MBResumeResponse | undefined>();
  const [iconSrc, setIconSrc] = useState<any | undefined>();
  const [iconState, setIconState] = useState<'stay' | 'change' | 'delete'>('stay');
  const [fileUpload, setFileUpload] = useState<FileResponse>();
  const [newEducation, setNewEducation] = useState<TFormValues | undefined>();
  const [updateEducations, setUpdateEducations] = useState<Array<number>>([]);
  const [delteEducations, setDelteEducations] = useState<{ e_id: string; index: number }[]>([]);
  const [educationCheck, setEducationCheck] = useState<boolean>(true);
  const [updatedKey, setUpdatedKey] = useState<string[]>([]);
  const [allCheck, setAllCheck] = useState<boolean>(true);
  const [scrollCheck, setScrollCheck] = useState<boolean>(false);
  const [scrolling, setScrolling] = useState<boolean>(false);
  const [modal, setModal] = useState<boolean>(false);
  const [modalContent, setModalContent] = useState<number>(1);
  const [checkInputData, setCheckInputData] = useState<TCheckInput>();
  const resumeKey = {
    user: [
      // 'name',
      // 'furigana',
      'gender',
      // 'birth',
      'postal_code',
      'address2',
      'address1',
      'email',
      'photo',
      // 'tel',
    ],
    // careers: ['careers'],
    // qualifications: ['qualifications'],
    resume: [
      'statement',
      'interest_things',
      'hope_job',
      'dependent_family',
      'partner',
      'duty_of_support',
    ],
  };

  const checkList = [
    'gender_check',
    'photo_check',
    'postal_code_check',
    'address1_check',
    'address2_check',
    'email_check',
    'education_check',
    'statement_check',
    'interest_things_check',
    'hope_job_check',
    'family_check',
  ];

  const setBeforeUnload = (flag: boolean) => {
    dispatch(setPrepareFrag(flag));
  };

  useEffect(() => {
    checkInputAgencyStatus();
  }, []);

  const checkInputAgencyStatus = async () => {
    const res = await new UserApi().getInputAgency();
    if (res.data && res.data.status !== 3) {
      history.push('/mypage/self-resume-cv/edit');
    } else {
      checkInput();
    }
  };

  const checkInput = async () => {
    const get_data = localStorage.getItem('checkInputData');
    if (get_data) {
      const parse_data: TCheckInput = JSON.parse(get_data);
      setCheckInputData(parse_data);
      if (!parse_data.resume_update || parse_data.resume_completed) {
        history.push('/mypage/cv/confirmation');
      } else {
        firstSetData();
      }
    } else {
      setModal(true);
      const data = {
        resume_update: false,
        resume_completed: false,
        cv_update: false,
        cv_completed: false,
      };
      const InputAgencyResumeRes: AxiosResponse<MBResumeResponse> =
        await new ResumeApi().getInputAgencyResume();
      const InputAgencyCHRes: AxiosResponse<CareerHistory & Status & UserInfo> =
        await new CareerHistoryApi().getInputAgencyCareerHistory();
      if (InputAgencyResumeRes.data.user?.last_update_resume) {
        data.resume_update = true;
      } else {
        data.resume_completed = true;
      }
      if (InputAgencyCHRes.data.latest_update) {
        data.cv_update = true;
      } else {
        data.cv_completed = true;
      }
      if (!InputAgencyResumeRes.data.user?.last_update_resume) {
        history.push('/mypage/cv/confirmation');
      } else {
        localStorage.setItem('checkInputData', JSON.stringify(data));
        setCheckInputData(data);
        firstSetData();
      }
    }
  };

  const firstSetData = async () => {
    const InputAgencyResumeRes: AxiosResponse<MBResumeResponse> =
      await new ResumeApi().getInputAgencyResume();
    if (InputAgencyResumeRes) {
      const { result, ...resumeInputAgencyData } = InputAgencyResumeRes.data;
      setInputAgencyResumeData(resumeInputAgencyData);
      setPreviewResumeData(InputAgencyResumeRes.data);
      if (InputAgencyResumeRes.data?.user?.user_info?.photo)
        setIconSrc(InputAgencyResumeRes.data?.user?.user_info?.photo.f_url);
    }

    const ResumeRes = await new ResumeApi().getResume();
    if (ResumeRes) {
      const { result, ...resumeData } = ResumeRes.data;
      setResumeData(resumeData);
    }
  };

  const birth = inputAgencyResumeData
    ? new Date(
        `${inputAgencyResumeData.user?.user_info?.birth_year}/${inputAgencyResumeData.user?.user_info?.birth_month}/${inputAgencyResumeData.user?.user_info?.birth_day}`
      )
    : new Date();

  const careers: CareerSummaryModel[] = [];
  if (inputAgencyResumeData?.careers) {
    Array.from(inputAgencyResumeData.careers.values()).forEach((career) => {
      const careersData: CareerSummaryModel = {
        c_id: '',
        c_company_name: '',
        c_join_date: '',
        c_leave_date: '',
        c_visible: true,
      };
      careersData.c_id = career.c_id;
      careersData.c_company_name = career.c_company_name;
      careersData.c_join_date = career.c_join_date;
      careersData.c_leave_date =
        career.c_leave_date && career.c_leave_flag ? career.c_leave_date : '現在';
      careersData.c_visible = career.c_visible;

      careers.push(careersData);
    });
  }

  const qualifications: Qualification[] = [];
  if (inputAgencyResumeData?.qualifications) {
    Array.from(inputAgencyResumeData.qualifications.values()).forEach((qualification) => {
      const qualificationsData: Qualification = {
        q_id: '',
        q_type: QualificationQTypeEnum.Text,
        q_title: '',
        q_date: '',
        q_score: '',
        q_visible: true,
      };
      qualificationsData.q_id = qualification.q_id;
      qualificationsData.q_type = qualification.q_type;
      qualificationsData.q_title = qualification.q_title;
      qualificationsData.q_date = qualification.q_date;
      qualificationsData.q_score = qualification.q_score;
      qualificationsData.q_visible = qualification.q_visible;

      qualifications.push(qualificationsData);
    });
  }

  const useFormProps: UseFormProps = {
    mode: 'onBlur',
    defaultValues: {},
  };
  const methods = useForm(useFormProps);

  useEffect(() => {
    if (inputAgencyResumeData) setDefaultData();
  }, [inputAgencyResumeData]);

  const setDefaultData = () => {
    methods.setValue(
      'name',
      inputAgencyResumeData ? inputAgencyResumeData.user?.user_info?.name : ''
    );
    methods.setValue(
      'furigana',
      inputAgencyResumeData ? inputAgencyResumeData.user?.user_info?.furigana : ''
    );
    methods.setValue(
      'gender',
      inputAgencyResumeData ? inputAgencyResumeData.user?.user_info?.gender?.toString() : ''
    );
    methods.setValue('birth', formatDate(birth, 'YYYY年MM月DD日'));
    methods.setValue(
      'tel',
      inputAgencyResumeData ? inputAgencyResumeData.user?.user_info?.tel : ''
    );
    methods.setValue(
      'postal_code',
      inputAgencyResumeData ? inputAgencyResumeData.user?.user_info?.postal_code : ''
    );
    methods.setValue(
      'email',
      inputAgencyResumeData ? inputAgencyResumeData.user?.user_info?.email : ''
    );
    methods.setValue(
      'address1',
      inputAgencyResumeData ? inputAgencyResumeData.user?.user_info?.address1 : ''
    );
    methods.setValue(
      'address2',
      inputAgencyResumeData ? inputAgencyResumeData.user?.user_info?.address2 : ''
    );
    // methods.setValue('careers', careers);
    // methods.setValue('qualifications', qualifications);
    methods.setValue(
      'statement',
      inputAgencyResumeData ? inputAgencyResumeData.resume?.statement : ''
    );
    methods.setValue(
      'interest_things',
      inputAgencyResumeData ? inputAgencyResumeData.resume?.interest_things : ''
    );
    methods.setValue(
      'hope_job',
      inputAgencyResumeData ? inputAgencyResumeData.resume?.hope_job : ''
    );
    methods.setValue(
      'dependent_family',
      inputAgencyResumeData ? inputAgencyResumeData.resume?.dependent_family : ''
    );
    methods.setValue(
      'partner',
      inputAgencyResumeData ? inputAgencyResumeData.resume?.partner?.toString() : ''
    );
    methods.setValue(
      'duty_of_support',
      inputAgencyResumeData ? inputAgencyResumeData.resume?.duty_of_support?.toString() : ''
    );
    methods.setValue('yyyy', formatDate(new Date(), 'YYYY'));
    methods.setValue('mm', formatDate(new Date(), 'MM'));
    methods.setValue('dd', formatDate(new Date(), 'DD'));
    methods.setValue(
      'educations',
      inputAgencyResumeData && inputAgencyResumeData.educations
        ? inputAgencyResumeData.educations
        : undefined
    );

    checkList.forEach((name) => {
      methods.setValue(name, true);
    });
  };

  const changeAllCheck = () => {
    checkList.forEach((name) => {
      methods.setValue(name, !allCheck);
    });
    setAllCheck(!allCheck);
  };

  const onSubmit = async () => {
    setModal(false);
    const formData = methods.getValues();
    const data: any = {
      user: { user_info: {} },
      // careers: [],
      // qualifications: [],
      resume: {},
      // educations: [],
    };
    dispatch(toggleLoading(true));
    try {
      // 更新があったkeyのみを変換して利用する
      Object.keys(formData).forEach(function (key) {
        // if (!updatedKey.includes(key)) return;

        if (resumeKey.user.includes(key)) {
          if (formData[key + '_check']) {
            data.user.user_info[key] = formData[key] !== '' ? formData[key] : null;
          }
          // } else if (resumeKey.careers.includes(key)) {
          //   data.careers = formData[key];
          // } else if (resumeKey.qualifications.includes(key)) {
          //   data.qualifications = formData[key];
        } else if (resumeKey.resume.includes(key)) {
          if (formData[key] === 'true') {
            formData[key] = true;
          } else if (formData[key] === 'false') {
            formData[key] = false;
          }
          if (key === 'duty_of_support' || key === 'dependent_family' || key === 'partner') {
            if (formData.family_check && formData[key]) data.resume[key] = formData[key];
          } else if (formData[key + '_check']) {
            data.resume[key] = formData[key] ? formData[key] : null;
          }
        }
      });

      // 学歴
      if (formData.education_check) {
        data.educations = await educationUpdate({ educations: formData.educations }, 'advance');
      }

      // 証明写真
      if (formData.photo_check === true) {
        if (fileUpload) {
          // const result = await new PortfolioApi().postFiles(iconSrc);
          // push({
          //   event: 'fileUpload',
          //   actionType: 'file_upload',
          //   actionName: '画像',
          // });
          // const fileData: FileResponse = result.data;
          data.user.user_info.photo = {
            f_id: fileUpload.f_id,
          };
        } else if (iconState === 'delete') {
          data.user.user_info.photo = {};
        }
      }

      // 履歴書
      const res = await new ResumeApi().patchResume(data as Resume);

      // 証明写真削除
      if (formData.photo_check) {
        if (resumeData?.user?.user_info?.photo?.f_id && iconState === 'delete') {
          await new PortfolioApi().deleteFiles(resumeData?.user?.user_info?.photo.f_id);
          dispatch(setUploadedImage(null));
        }
      }

      // const { result, ...resume } = res.data;
      // setResumeData(resume);
      setIconState('stay');
      setUpdatedKey([]);
      setUpdateEducations([]);
      setDelteEducations([]);
      // setNewEducation(undefined);
      setBeforeUnload(false);
      dispatch(setSaved(true));
      // 確認ボタンの場合はプレビューに進む
      // const event = e as React.BaseSyntheticEvent<Record<string, unknown>, any, any> | undefined;
      // const button = event?.nativeEvent?.submitter as HTMLButtonElement;
      // if (button.textContent === '反映を確定する') history.push('/mypage/cv/confirmation');
      const saveData = checkInputData;
      if (saveData) saveData.resume_completed = true;
      if (checkInputData?.cv_completed) {
        await new UserApi().patchInputAgency({ status: 4 });
        localStorage.removeItem('checkInputData');
        if (userState?.use_direct) {
          setModalContent(5);
        } else {
          setModalContent(4);
        }
      } else {
        localStorage.setItem('checkInputData', JSON.stringify(saveData));
        setModalContent(3);
      }
      setModal(true);
    } catch (e) {
      // ロールバック処理
      if (newEducation && resumeData?.educations) {
        await educationUpdate(
          { educations: Array.from(resumeData?.educations) } as TFormValues,
          'revert'
        );
      }
      if (data.user.user_info.photo && data.user.user_info.photo.f_id) {
        await new PortfolioApi().deleteFiles(data.user.user_info.photo.f_id);
      }
      await new ResumeApi().patchResume(resumeData);
      const error = e as AxiosError<ResponseError>;
      if (error.response) dispatch(notificationError(error.response.data.error_message));
    } finally {
      dispatch(toggleLoading(false));
    }
  };

  const educationUpdate = async (
    data: TFormValues,
    state: 'advance' | 'revert'
  ): Promise<EducationData[]> => {
    const postEducations: (EducationPatchRequest & { index: number })[] = [];
    // const patchEducations: EducationPatchRequest[] = [];
    const delEducations: { e_id: string; index: number }[] = [];
    const newEducations: EducationData[] = cloneDeep(data.educations);

    data.educations.forEach((value, index) => {
      const data: EducationPatchRequest = {
        e_id: '',
        e_school_name: value.e_school_name,
        e_graduate_date: value.e_graduate_date_yyyy + '-' + value.e_graduate_date_mm,
      };
      if (!value.e_graduate_date_yyyy && !value.e_graduate_date_mm) data.e_graduate_date = null;
      if (!data.e_id) postEducations.push({ ...data, index: index });
      // if (state === 'advance' && updateEducations.includes(Number(data.e_id))) {
      //   patchEducations.push(data);
      // } else if (state === 'revert') {
      //   const revertValue = value as EducationData;
      //   data.e_graduate_date = revertValue.e_graduate_date;
      //   patchEducations.push(data);
      // }
    });

    if (state === 'revert') {
      // 既に登録された学歴を取得する
      new ResumeApi().getResume().then((res) => {
        const response = res.data;
        if (response.educations) {
          Array.from(response.educations).forEach((reRducation, index) => {
            if (
              data.educations.filter((education) => education.e_id === reRducation.e_id).length ===
              0
            ) {
              delEducations.push({ e_id: reRducation.e_id, index: index });
            }
          });
        }
      });
    }
    // 登録処理
    if (postEducations.length !== 0) {
      for (let i = 0; i < postEducations.length; i++) {
        const { index, ...postEducation } = postEducations[i];
        const res = await new ResumeApi().postResumeUserIdEducations(postEducation);
        const educations = res.data.educations;
        newEducations[index] = educations[educations.length - 1];
      }
    }
    // 更新処理
    // if (patchEducations.length !== 0) {
    //   for (let i = 0; i < patchEducations.length; i++) {
    //     await new ResumeApi().patchResumeUserIdEducations(patchEducations[i]);
    //   }
    // }
    // 削除処理
    // if (delEducations.length !== 0) {
    //   for (let i = 0; i < delEducations.length; i++) {
    //     await new ResumeApi().deleteResumeEducations(delEducations[i].e_id);
    //   }
    // }
    // 既存のデータ削除処理
    if (state === 'advance' && resumeData?.educations) {
      Array.from(resumeData.educations.values()).forEach(async (education) => {
        await new ResumeApi().deleteResumeEducations(education.e_id);
      });
    }

    return newEducations;
  };

  const changePreview = async () => {
    dispatch(toggleLoading(true));
    window.scrollTo(0, 0);

    const data: any = {
      user: { user_info: {} },
      // careers: [],
      // qualifications: [],
      resume: {},
      educations: [],
    };

    const formData = methods.getValues();
    Object.keys(formData).forEach(function (key) {
      if (resumeKey.user.includes(key)) {
        const info_key = key as unknown as TUserInfoKey;
        if (formData[info_key + '_check']) {
          if (info_key === 'gender') {
            data.user.user_info[info_key] =
              formData[info_key] !== '' ? Number(formData[info_key]) : null;
          } else {
            data.user.user_info[info_key] = formData[info_key] !== '' ? formData[info_key] : null;
          }
        } else if (resumeData && resumeData.user?.user_info) {
          data.user.user_info[info_key] = resumeData.user?.user_info[info_key]
            ? resumeData.user?.user_info[info_key]
            : null;
        }
      } else if (resumeKey.resume.includes(key)) {
        const resume_key = key as unknown as TUserResumeKey;
        if (formData[resume_key] === 'true') {
          formData[resume_key] = true;
        } else if (formData[resume_key] === 'false') {
          formData[resume_key] = false;
        }
        if (
          resume_key === 'duty_of_support' ||
          resume_key === 'dependent_family' ||
          resume_key === 'partner'
        ) {
          if (formData.family_check) {
            data.resume[resume_key] = formData[resume_key] ? formData[resume_key] : null;
          } else if (resumeData?.resume) {
            data.resume[resume_key] = resumeData?.resume[resume_key];
          }
        } else {
          if (formData[resume_key + '_check']) {
            data.resume[resume_key] = formData[resume_key] ? formData[resume_key] : null;
          } else if (resumeData?.resume) {
            data.resume[resume_key] = resumeData?.resume[resume_key];
          }
        }
      }
    });
    if (formData['photo_check']) {
      if (iconState === 'change' && iconSrc) {
        if (fileUpload) {
          await new PortfolioApi().deleteFiles(fileUpload.f_id);
          setFileUpload(undefined);
        }
        const result = await new PortfolioApi().postFiles(iconSrc);
        const fileData: FileResponse = result.data;
        push({
          event: 'fileUpload',
          actionType: 'file_upload',
          actionName: '画像',
        });
        data.user.user_info.photo = {
          f_id: fileData.f_id,
          f_thumbnail: fileData.f_thumbnail,
          f_url: fileData.f_url,
        };
        setFileUpload(fileData);
        setIconSrc(fileData.f_url);
        setIconState('stay');
        // } else if (iconState === 'stay') {
      } else if (iconState === 'delete') {
        data.user.user_info.photo = {};
      }
    } else {
      data.user.user_info.photo = resumeData?.user?.user_info?.photo
        ? resumeData?.user?.user_info?.photo
        : {};
    }

    if (formData['education_check']) {
      const prevEducations: EducationData[] = [];
      formData.educations.forEach((item: any) => {
        item.e_graduate_date = item.e_graduate_date_yyyy + '-' + item.e_graduate_date_mm;
        prevEducations.push(item);
      });
      data.educations = prevEducations;
    } else {
      data.educations = resumeData?.educations;
    }

    if (previewResumeData) {
      setPreviewResumeData({
        ...previewResumeData,
        user: {
          ...previewResumeData?.user,
          user_info: {
            ...previewResumeData?.user?.user_info,
            ...data.user.user_info,
          },
        },
        resume: { ...previewResumeData?.resume, ...data.resume },
        educations: data.educations,
        // ...data,
      });
    }
    setPreview(true);
    dispatch(toggleLoading(false));
  };

  const clickModalClose = () => {
    setModal(false);
    if (modalContent === 3 || modalContent === 4 || modalContent === 5) {
      history.push('/mypage/resume');
    }
  };

  const resetData = () => {
    firstSetData();
    setAllCheck(true);
    setModal(false);
  };

  const scrollChange = () => {
    if (document.documentElement.scrollTop < 300) {
      setScrollCheck(false);
    } else {
      setScrollCheck(true);
    }
  };

  const scrollEnd = () => {
    setScrolling(false);
  };

  let timeoutId: number;
  const timeoutScroll = () => {
    if (document.documentElement.scrollTop > 300) {
      setScrolling(true);
    }
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(scrollEnd, 100);
  };

  useEffect(() => {
    const subscription = methods.watch((value, { name }) => {
      if (name && name.indexOf('_check') > -1) {
        if (value[name] == false) setAllCheck(false);
      }
    });
    return () => subscription.unsubscribe();
  }, [methods.watch]);

  useEffect(() => {
    window.addEventListener('scroll', scrollChange);
    window.addEventListener('scroll', timeoutScroll);

    return () => {
      window.removeEventListener('scroll', scrollChange);
      window.removeEventListener('scroll', timeoutScroll);
    };
  }, []);

  return (
    <Wrapper
      type={preview ? 'preview' : undefined}
      header={
        <>
          {!preview ? (
            <div className={cn('sticky top-0 z-10 duration-300', { 'opacity-40': scrolling })}>
              <section className="header-title">
                <div className="header-title_inner lg:w-960 relative">
                  <p
                    className={cn('title absolute transition-opacity', {
                      'opacity-0': scrollCheck,
                    })}
                  >
                    MATCHBOX入力代行【履歴書】
                  </p>
                  <div
                    className={cn('flex items-center opacity-0 transition-opacity', {
                      'opacity-100': scrollCheck,
                    })}
                  >
                    <div className="mr-8">
                      <label className="mbx-formToggle mbx-formToggle-select">
                        <input
                          type="checkbox"
                          checked={allCheck}
                          onChange={() => changeAllCheck()}
                        />
                        <div className="mbx-formToggle-body">
                          <p className="mbx-formToggle-true">YES</p>
                          <p className="mbx-formToggle-false">NO</p>
                        </div>
                      </label>
                    </div>
                    <p className="text-14_21 whitespace-nowrap font-bold">
                      入力代行された内容をすべてに反映する
                    </p>
                  </div>
                  <div className="children-area">
                    <div className="flex justify-end sp_none">
                      <BaseButton
                        theme="secondary"
                        size="40"
                        width="large"
                        className="pr-10"
                        onClick={() => {
                          setModalContent(6);
                          setModal(true);
                        }}
                      >
                        リセットする
                      </BaseButton>
                      <BaseButton theme="primary" size="40" width="large" onClick={changePreview}>
                        反映を確認する
                      </BaseButton>
                    </div>
                  </div>
                </div>
              </section>
              <div className="sp_only">
                <div className="bg-gray-200 border-b border-gray-300 h-48 flex items-center	justify-end">
                  <BaseButton
                    theme="secondary"
                    size="40"
                    width="large"
                    className="pr-10"
                    onClick={() => {
                      setModalContent(6);
                      setModal(true);
                    }}
                  >
                    リセットする
                  </BaseButton>
                  <BaseButton
                    theme="primary"
                    size="40"
                    width="large"
                    className="pr-16"
                    onClick={changePreview}
                  >
                    反映を確認する
                  </BaseButton>
                </div>
              </div>
            </div>
          ) : (
            <div className="sticky top-0 z-10">
              <HeaderTitle title="MATCHBOX入力代行【履歴書】">
                <div className="flex justify-end space-x-8 sp_none">
                  <BaseButton
                    className="mbx-top-preview-edit-button"
                    theme="secondary"
                    size="40"
                    width="large"
                    onClick={() => {
                      setPreview(false);
                      window.scrollTo(0, 0);
                    }}
                  >
                    編集する
                  </BaseButton>
                  <BaseButton
                    className="mbx-top-preview-edit-button"
                    theme="primary"
                    size="40"
                    width="large"
                    onClick={() => {
                      setModalContent(2);
                      setModal(true);
                    }}
                  >
                    反映を確定する
                  </BaseButton>
                </div>
              </HeaderTitle>
              <div className="sp_only">
                <div className="bg-gray-200 border-b border-gray-300 h-48 flex items-center	justify-end">
                  <BaseButton
                    className="mr-10"
                    theme="secondary"
                    size="40"
                    width="large"
                    onClick={() => {
                      setPreview(false);
                      window.scrollTo(0, 0);
                    }}
                  >
                    編集する
                  </BaseButton>
                  <BaseButton
                    className="mr-16"
                    theme="primary"
                    size="40"
                    width="large"
                    onClick={() => {
                      setModalContent(2);
                      setModal(true);
                    }}
                  >
                    反映を確定する
                  </BaseButton>
                </div>
              </div>
            </div>
          )}
        </>
      }
    >
      <>
        <div className="sticky top-66 sm:top-108 z-10 mt-16 pb-16">
          <NotificationMatchbou
            show={notification}
            showMatchbou={false}
            onClick={() => setNotification(false)}
          >
            MATCHBOX事務局に入力代行された履歴書です。修正が必要な場合は編集の上、反映を確定させてください。
          </NotificationMatchbou>
        </div>
        <div className={cn({ hidden: preview })}>
          <Column
            main={
              <div className="pt-48 pb-100 sm:pt-24 mt-16 sm:mt-54">
                <FormContainer
                  methods={methods as UseFormReturn<FieldValues, Record<string, unknown>>}
                  useFormProps={useFormProps}
                  onSubmit={onSubmit}
                  fetchData={inputAgencyResumeData}
                  id="pagesResume"
                  setUpdatedKey={setUpdatedKey}
                  setBeforeUnload={setBeforeUnload}
                >
                  <div className="mbx-utils-stack-v--48">
                    <ResumeFormSectionProfile
                      id="Profile"
                      iconSrc={iconSrc}
                      setIconSrc={setIconSrc}
                      setIconState={setIconState}
                      original={{
                        gender: resumeData?.user?.user_info?.gender,
                        photo: resumeData?.user?.user_info?.photo,
                      }}
                    />
                    <ResumeFormSectionAddress
                      id="Address"
                      original={{
                        postal_code: resumeData?.user?.user_info?.postal_code,
                        address1: resumeData?.user?.user_info?.address1,
                        address2: resumeData?.user?.user_info?.address2,
                        email: resumeData?.user?.user_info?.email,
                      }}
                    />
                    <ResumeFormSectionEducations
                      id="Education"
                      fetchData={inputAgencyResumeData}
                      newEducation={newEducation}
                      setNewEducation={setNewEducation}
                      setUpdateEducations={setUpdateEducations}
                      setDelteEducations={setDelteEducations}
                      original={resumeData?.educations}
                      educationCheck={educationCheck}
                      setEducationCheck={setEducationCheck}
                    />
                    {/* <ResumeFormSectionCareer id="Career" />
                    <ResumeFormSectionQualification id="Qualification" /> */}

                    <div id="Career">
                      <TitleSectionTitle type="large" className="mt-12">
                        職歴
                      </TitleSectionTitle>
                      <div className="flex items-center justify-center text-body_1 bg-gray-50 h-140 sm:h-100 p-16 w-full text-center">
                        <div>
                          履歴書を確認後、職務経歴書から
                          <br />
                          職歴を確認してください。
                        </div>
                      </div>
                    </div>

                    <div id="Qualification">
                      <TitleSectionTitle type="large" className="mt-12">
                        資格・免許
                      </TitleSectionTitle>
                      <div className="flex items-center justify-center text-body_1 bg-gray-50 h-140 sm:h-100 p-16 w-full text-center">
                        <div>
                          履歴書を確認後、職務経歴書から
                          <br />
                          資格・免許を確認してください。
                        </div>
                      </div>
                    </div>

                    <ResumeFormSectionStatement
                      id="Statement"
                      original={resumeData?.resume?.statement}
                    />
                    <ResumeFormSectionInterestThings
                      id="InterestThings"
                      original={resumeData?.resume?.interest_things}
                    />
                    <ResumeFormSectionHopeJob
                      id="HopeJob"
                      original={resumeData?.resume?.hope_job}
                    />
                    <ResumeFormSectionFamily
                      id="Family"
                      original={{
                        dependent_family: resumeData?.resume?.dependent_family,
                        partner: resumeData?.resume?.partner,
                        duty_of_support: resumeData?.resume?.duty_of_support,
                      }}
                    />
                    <ResumeFormSectionLastUpdate />
                  </div>
                </FormContainer>
              </div>
            }
            menu={<></>}
          />
        </div>
        <div className={cn({ hidden: !preview })}>
          <PagesResumeConfirmationPreview resumeData={previewResumeData} />
        </div>
        <div className="sm:mb-170"></div>
        <Modal isOpen={modal} isClose={() => clickModalClose()} className="rounded-modalContainer">
          <ConfirmationModal type={modalContent} object="履歴書">
            <div className="w-308 mt-24 mx-auto sm:w-full">
              {/* 入力代行完了 */}
              {modalContent === 1 && (
                <>
                  <BaseButton
                    className="w-full"
                    size="m"
                    theme="primary"
                    type="button"
                    onClick={() => clickModalClose()}
                  >
                    情報を確認する
                  </BaseButton>
                  <BaseButton href="/mypage" className="mt-16" size="m" theme="link" type="button">
                    マイページへ戻る
                  </BaseButton>
                </>
              )}
              {/* 反映する */}
              {modalContent === 2 && (
                <>
                  <BaseButton
                    className="w-full"
                    size="m"
                    theme="primary"
                    onClick={() => onSubmit()}
                  >
                    反映を確定する
                  </BaseButton>
                  <BaseButton
                    className="mt-16 w-full"
                    size="m"
                    theme="secondary"
                    type="button"
                    onClick={() => setModal(false)}
                  >
                    編集へ戻る
                  </BaseButton>
                </>
              )}
              {/* 履歴書完了 */}
              {modalContent === 3 && (
                <>
                  <BaseButton
                    href="/mypage/cv/confirmation"
                    className="w-full"
                    size="m"
                    theme="primary"
                    type="button"
                  >
                    情報を確認する
                  </BaseButton>
                  <BaseButton href="/mypage" className="mt-16" size="m" theme="link" type="button">
                    マイページへ戻る
                  </BaseButton>
                </>
              )}
              {/* 完了＆オファー登録 */}
              {modalContent === 4 && (
                <>
                  <BaseButton
                    href="/mypage/direct"
                    className="w-full"
                    size="m"
                    theme="primary"
                    type="button"
                  >
                    オファー機能に登録する
                  </BaseButton>
                  <BaseButton href="/mypage" className="mt-16" size="m" theme="link" type="button">
                    マイページへ戻る
                  </BaseButton>
                </>
              )}
              {/* 完了 */}
              {modalContent === 5 && (
                <>
                  <BaseButton
                    href="/mypage"
                    className="w-full"
                    size="m"
                    theme="primary"
                    type="button"
                  >
                    マイページへ戻る
                  </BaseButton>
                </>
              )}
              {/* リセット */}
              {modalContent === 6 && (
                <>
                  <BaseButton
                    className="w-full"
                    size="m"
                    theme="primary"
                    type="button"
                    onClick={resetData}
                  >
                    リセットする
                  </BaseButton>
                  <BaseButton
                    className="mt-16 w-full"
                    size="m"
                    theme="secondary"
                    type="button"
                    onClick={() => setModal(false)}
                  >
                    編集へ戻る
                  </BaseButton>
                </>
              )}
            </div>
          </ConfirmationModal>
        </Modal>
      </>
    </Wrapper>
  );
};
